// The run page: header, facts, status timeline, cost, broker calls and the host's view.
export default {
  couldNotLoad: "Could not load run",
  couldNotLoadQuestions: "Could not load questions",
  agentFallback: "Agent",
  result: "Result",
  runAgain: "Run again",
  cancel: "Cancel run",
  cancelled: "Run cancelled",
  queued: "Run queued",
  facts: {
    label: "Run facts",
    run: "Run",
    where: "Where",
    trigger: "Trigger",
    took: "Took",
    runningFor: "Running for",
    worker: "Worker",
    deadline: "Deadline",
    withRun: "with the run",
  },
  worker: { present: "present", absent: "absent", notYet: "not yet", destroyed: "destroyed" },
  status: "Status",
  timeline: {
    queued: "Queued",
    queuedDetail: "Waiting for a worker slot",
    workerStarted: "Worker started",
    workerDetail: "Hardened container; capability token minted",
    agentRunning: "Agent running",
    agentDetail: "Through ocs-capture, which encrypts what it says",
    askedYou: "Asked you",
    askedDetail: "Resumes when you answer",
    completed: "Completed",
    endedDetail: "Worker destroyed; results kept",
    pendingDetail: "Result stored, worker destroyed",
    ended: { succeeded: "Succeeded", failed: "Failed", timed_out: "Timed out", cancelled: "Cancelled", skipped: "Skipped" },
  },
  cost: {
    title: "Cost and tokens",
    soFar: "so far",
    inTotal: "in total",
    apiPrice: "API-equivalent price",
    tokens: "tokens",
    input: "Input",
    output: "Output",
  },
  broker: {
    title: "Broker calls",
    description: "Made for this run with credentials the worker never held",
    emptyTitle: "No broker calls",
    notReported: "This host's ocs-api does not report broker calls yet.",
    noneRecent: "None among the organisation's latest calls.",
  },
  host: {
    title: "What the host can read",
    metadata: "Metadata, in the clear",
    onlyDevices: "Only your devices",
    can: [
      "Run, workflow and workspace ids",
      "Event types, sequence numbers and timestamps",
      "Which tool was called, by name",
      "Sizes of each event and token counts",
      "That a question is pending, and when you answered",
    ],
    cannot: ["Your prompt and the agent's replies", "The question text and your answer", "Tool arguments and results (file contents, diffs)", "The agent's reasoning"],
  },
};
